import React from 'react';

const Frontend = () => {
    return (
        <div className="skills__content">
            <h3 className="skills__title">Frontend developer</h3>

            <div className="skills__box">
                <div className="skills__group">
                    {/* HTML/CSS skill */}
                    <div className="skills__data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills__name">HTML CSS</h3>
                            <div className="skills__level">Advanced</div>
                        </div>
                    </div>

                    {/* JavaScript skill */}
                    <div className="skills__data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills__name">JavaScript</h3>
                            <div className="skills__level">Advanced</div>
                        </div>
                    </div>

                    {/* Tailwind CSS skill */}
                    <div className="skills__data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills__name">Tailwind CSS</h3>
                            <div className="skills__level">Advanced</div>
                        </div>
                    </div>
                </div>

                <div className="skills__group">
                    {/* React skill */}
                    <div className="skills__data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills__name">React</h3>
                            <div className="skills__level">Intermediate</div>
                        </div>
                    </div>

                    {/* Git/GitHub skill */}
                    <div className="skills__data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills__name">Git</h3>
                            <div className="skills__level">Advanced</div>
                        </div>
                    </div>

                    {/* Adaptive UI skill */}
                    <div className="skills__data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills__name">TypeScript </h3>
                            <div className="skills__level">Intermediate</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Frontend;
